__turbopack_context__.v({
  "className": "avertaregularlight_bdec9f60-module__XKqL7W__className",
  "variable": "avertaregularlight_bdec9f60-module__XKqL7W__variable",
});
